import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieComponent } from './cookie.component';

@NgModule({
  declarations: [CookieComponent],
  imports: [
    CommonModule
  ],
  exports: [CookieComponent],
})
export class CookieModule { }
